/**
 * Resolves the default phone region (ISO 3166-1 alpha-2, lowercase) for kiosk phone inputs.
 * Priority: explicit config (e.g. plugin) → marketplace country → 'fr'.
 */
export function resolvePhoneDefaultRegionCode(
  explicit: string | null | undefined,
  marketplaceCountry: string | null | undefined,
): string {
  const trimmedExplicit = explicit?.trim();
  if (trimmedExplicit) {
    return trimmedExplicit.toLowerCase();
  }
  const trimmedMarketplace = marketplaceCountry?.trim();
  if (trimmedMarketplace) {
    return trimmedMarketplace.toLowerCase();
  }
  return 'fr';
}
